import React from "react";
import { connect } from "react-redux";

import TabBar from "../components/Tabs/TabBar";
import ExpandableList from "../components/ExpandableList/ExpandableList";

const URL_API_MAPPING = {
  ready: "Arrived",
  otw: "On the way",
  complete: "Picked up"
};

class Packages extends React.Component {
  constructor(props) {
    super(props);
    this.currentOpenTab = this.currentOpenTab.bind(this);

    this.state = {
      currentTab: this.currentOpenTab()
    };
  }

  currentOpenTab = () => {
    return this.props.location.pathname.substring(
      this.props.location.pathname.lastIndexOf("/") + 1
    );
  };

  componentDidUpdate(prevProps) {
    if (prevProps.location.pathname !== this.props.location.pathname) {
      this.setState({ currentTab: this.currentOpenTab() });
    }
  }

  render() {
    return (
      <div
        style={{
          flex: 1,
          display: "flex",
          flexDirection: "column"
        }}
      >
        <TabBar />
        <div style={{ flex: 1, overflow: "auto", display: "flex" }}>
          {this.props.userData.packages &&
          this.props.userData.packages[
            URL_API_MAPPING[this.state.currentTab]
          ] &&
          this.props.userData.packages[URL_API_MAPPING[this.state.currentTab]]
            .length > 0 ? (
            <ExpandableList
              packageList={
                this.props.userData.packages[
                  URL_API_MAPPING[this.state.currentTab]
                ]
              }
            />
          ) : (
            <div style={{ alignSelf: "center", textAlign: "center" }}>
              <img
                src={require("../assets/empty_box/empty_mailbox3.jpg")}
                alt="Empty view"
                style={{ width: "100%" }}
              />
              <span>
                No packages{" "}
                {URL_API_MAPPING[this.state.currentTab].toLowerCase()} yet!
              </span>
            </div>
          )}
        </div>
      </div>
    );
  }
}

const mapDispatchToProps = dispatch => ({});

const mapStateToProps = state => ({
  ...state
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Packages);
